module.exports = __webpack_public_path__ + "static/media/skill.8c2c5458.svg";